import * as Yup from 'yup'

export const SchemaValidation = (t) => Yup.object().shape({
  name: Yup.string().required(t('required')),
  description: Yup.string().nullable(),
  company: Yup.string().required(t('required')),
  branch_office: Yup.string().required(t('required')),
  menu: Yup.string().required(t('required')),
  active: Yup.boolean().required(t('required')),
})

export const ValidationSchemaStyle = Yup.object().shape({
  size: Yup.number().typeError("Campo requerido"),
  margin: Yup.number().typeError("Campo requerido"),
  image: Yup.string(),
  background: Yup.string(),
  points_style: Yup.string(),
  points_color: Yup.string(),
  corners_square_style: Yup.string(),
  corners_square_color: Yup.string(),
  corners_dot_style: Yup.string(),
  corners_dot_color: Yup.string()
})